import { Component, OnInit } from '@angular/core';
import { RouterService, StateService } from 'projects/shared/src/public-api';

@Component({
    selector: 'app-settings',
    templateUrl: './settings.component.html',
    styleUrls: ['./settings.component.scss'],
    standalone: false
})
export class SettingsComponent implements OnInit {
  constructor(
    public state: StateService,
    public routerService: RouterService
  ) {}

  ngOnInit() {}
}
